export const getVideoThumbnail = async (videoUrl: string) => {
  if (!videoUrl) return '';

  const video = document.createElement('video');
  video.crossOrigin = 'anonymous';
  video.preload = 'metadata';
  video.src = `${videoUrl}#t=1`;

  await new Promise<void>((resolve, reject) => {
    /* Fix Chrome generates a black thumbnail  */
    video.addEventListener('loadedmetadata', () => {
      video.currentTime = 1;
    });

    video.addEventListener('seeked', () => resolve());
    video.addEventListener('error', () =>
      reject(new Error('Error al cargar el video'))
    );
  });

  const canvas = document.createElement('canvas');
  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;

  const ctx = canvas.getContext('2d');
  if (!ctx) return '';

  ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  return canvas.toDataURL('image/jpeg', 0.8);
};
